<template>
  <div class="article-1">
    <div class="article__info">
      <h1 class="article__title"><span>台南第六選區綠到出汁</span><span>柱柱姐能破鐵桿泛綠？</span></h1>
      <div class="article__reporter">聯合報 記者：張文馨、修瑞瑩、周宗禎、鄭維真／報導</div>
    </div>
    <figure class="article__figure article__cover">
      <div class="article__figure-photo" :style="`background-image: url(${require('@/assets/articles/article-1-cover.jpg')})`"></div>
      <figcaption class="article__figure-caption">國民黨前主席洪秀柱將投入台南巿第六選區的立委選舉；圖為她與國民黨總統參選人韓國瑜相互打氣。圖／本報資料照</figcaption>
    </figure>
    <p class="article__paragraph">「台南市」向來被視為「綠到出汁」的選舉區，不過，從歷年藍綠政治版圖的變化，曾任國民黨主席的洪秀柱要挑戰當地第六選區，只要能破解過去十年這選區綠化的原因，提高催票率，仍有機會一搏，寫下歷史。</p>
    <p class="article__paragraph">台南第六選區是下屆立委新調整的選區，原本是永康、仁德、歸仁、關廟、龍崎區，永康被畫為新選區第四選區，第六選區除了仁德等4區外，再加上三分之二的東區29里，藍綠基本盤即將重新洗牌。</p>

    <h2 class="article__subtitle">過去十年，不斷綠化<br/>去年選舉，藍營才止跌</h2>
    <p class="article__paragraph">根據中選會選舉資料庫，現在的台南市第六選區所有村里，從2008年起歷經的三次立委選舉中，曾掀起一股地殼變動。2008年，藍綠只相差726票，從此一路拉大差距，從2012年差距的4892票，到2016年已擴大到6萬4099票。</p>
    <p class="article__paragraph">近十年來，這個區一路綠化的原因，一位熟悉地方生態的黨政人士說，主要是綠營長期地方執政，注入許多資源，並且招兵買馬，培養中青世代，爭取選民的認同；相較之下，國民黨中生代人才出現斷層，加上大環境不利，造成地方上鮮少有高知名度的「戰士」，不少人寧願選擇當一位抬轎者就好。</p>
    <p class="article__paragraph">他說，早期國民黨有培訓公務人員「菁英班」，中山獎學金等栽培學子，後來這些培訓都不見了，藍營老班底相互卡位，不栽培新人，遇到選舉時，就隨便派人空降上場，甚至抓黨工參選，許多人選輸後就離開，缺乏長期耕耘的。</p>
    <p class="article__paragraph">直至去年，外界認為韓流帶動其他縣市首長選情，國民黨推出的高思博在該選區開出5萬3925票，已超越2016年的得票數，才終於止跌回穩，但仍未恢復到2012年、2008年時的藍營榮景。</p>

    <div class="article__chart">
      <div class="article__chart-caption">第六選區歷年選舉得票情況</div>
      <div class="article__chart-table article-1__chart-table-1">
        <SvgSymbol class="svg" use="#article-1-chart-1"/>
      </div>
      <div class="article__chart-guide">資料來源：中選會/本文自行彙整</div>
    </div>

    <h2 class="article__subtitle">鐵桿泛藍，投票結構穩定<br/>鐵桿泛綠，曾經出現破口</h2>
    <p class="article__paragraph">再從另一個統計數字分析，台南市第六選區也確實存在鐵桿泛綠、鐵桿泛藍的普遍現象。</p>
    <p class="article__paragraph">該選區近三次立委選舉的得票，出現統計上的<Dictionary word="高度相關" meaning="高度相關，一般研究認為，相關係數0.3以下為低相關，0.3~0.7為中等相關，0.7以上為高度相關；這裡指藍綠受到環境變動影響下，得票是否依然堅實，相關係數愈高，代表得票愈穩定。"/>。國民黨雖然在2016年立委選舉的得票率下滑，但這三次選舉的相關係數仍超過0.7，顯示相當穩定性；至於民進黨在2016年立委選舉，因為王定宇拿下11萬1票的綠營歷史高點，表面上雖取得絕對優勢，但2012年立委選舉的相關係數未達0.7，不若藍營穩定，顯示綠營並非密不可破。</p>

    <div class="article__chart">
      <div class="article__chart-caption">第六選區歷年立委選舉得票率相關係數統計</div>
      <div class="article__chart-table article-1__chart-table-2">
        <SvgSymbol class="svg" use="#article-1-chart-2"/>
      </div>
      <div class="article__chart-guide">資料來源：中選會/本文自行彙整</div>
    </div>

    <p class="article__paragraph">過去十年，藍綠勢力由五五波，逐漸變成三七的差距，去年因為市長選舉多組人馬競爭，加上中央政府執政不利因素，開始縮小藍綠的落差，如今，隨著選區重新劃分出現的變化，台南巿很可能不再是鐵板一塊。</p>

    <!-- <h2 class="article__subtitle"></h2>
    <p class="article__paragraph"></p> -->

    <div class="article-1__remark">
      <h3 class="article-1__remark-title">得票率 vs 催票率</h3>
      <div class="article-1__remark-formula">
        <p>得票率=得票數／投票數</p>
        <p>催票率=得票數／總選舉人數</p>
      </div>
      <p class="article-1__remark-paragraph">一般來說，選民習慣以「得票率」分析政黨在一個選區的勢力大小，至於台大政治系教授<Dictionary word="洪永泰" meaning="曾任東海大學統計學系副教授兼主任，政治大學選舉研究中心主任，台灣大學政治學系教授暨台灣大學調查研究中心主任。研究領域包括抽樣調查、投票行為與選舉預測、統計指標、社會科學統計方法，是台灣首屈一指的選舉預測分析專家。"/>倡議的「催票率」，其實更接近「地盤」、「政治版圖」的概念，也就是在當次選舉中，政黨推派的候選人能帶動多少支持者出來投票。</p>
      <p class="article-1__remark-paragraph">從催票率來觀察，可排除不同年度投票率所造成的不同誤差，例如，2008年立委選舉，藍綠催票率各約3成，2012年則是逼近4成，劇變的2016年，民進黨催出45%，但國民黨卻只有17%，更能解釋當時的投票情況。</p>
      <p class="article-1__remark-paragraph">世新大學行管系教授<Dictionary word="莊文忠" meaning="國立政治大學博士，現任世新大學行政管理系教授，台灣透明組織協會理事，以及中華組織發展協會理事。研究領域為公共政策分析、研究方法、政府績效管理、民意調查。"/>說，得票率和催票率雖然在方向上是一致的，都可以作為長期趨勢的觀察視角，但催票率更像是政黨在選區的「素顏」，尤其是當投票率偏低時，催票率反而能真實反映出政黨的動員能量。</p>
      <br/>
      <small>更新日期： 2019 / 12 / 26</small>
    </div>
  </div>
</template>

<script>
import Dictionary from '@/components/Dictionary'

export default {
  name: 'Article1',
  components: {
    Dictionary
  }
}
</script>

<style lang="scss">
.article-1 {
  &__remark {
    position: relative;
    margin: 50px 6px;
    padding: 35px 30px 35px 35px;
    border: 4px solid #cccccc;
    @include rwd($RWD_TABLET_SMALL) {
      margin: 30px 35px;
      padding: 35px 25px 30px 35px;
    }
    @include rwd($RWD_TABLET) {
      margin: 45px 50px;
      padding: 35px 25px 30px 35px;
    }
    @include rwd($RWD_DESKTOP) {
      margin: 50px;
      padding: 35px 25px 45px 35px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin: 60px 0;
      padding: 35px 25px 50px 55px;
    }

    &:before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 10px;
      width: 9px;
      height: 57px;
      background: #cccccc;
    }

    &-title {
      font-size: 1em;
      font-weight: bold;
      letter-spacing: 0.1em;
      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1.125em;
      }
      @include rwd($RWD_DESKTOP) {
        font-size: 1.25em;
      }
    }

    &-formula {
      margin: 20px 0 0 0;
      font-size: 0.875em;
      line-height: 1.375em;
      letter-spacing: 0.1em;
      @include rwd($RWD_DESKTOP) {
        margin: 30px 0 0 0;
        font-size: 1em;
      }

      p {
        margin: 0;
      }
    }

    &-paragraph {
      margin: 25px 0 0 0;
      font-size: 0.875em;
      line-height: 1.375em;
      letter-spacing: 0.1em;
      @include rwd($RWD_DESKTOP) {
        margin: 35px 0 0 0;
        font-size: 1em;
      }
    }

    &-paragraph + &-paragraph {
      margin: 20px 0 0 0;
    }
  }

  &__chart-table-1 {
    @include use-fixed-ratio(899, 175);
  }

  &__chart-table-2 {
    @include use-fixed-ratio(972, 700);
  }
}
</style>
